module.exports = __webpack_public_path__ + "static/mca-wireframes-01.7bcedc44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/mca/mca-wireframes-01.jpg
// module id = 477
// module chunks = 181542127041897